/* ---------------------------------------------------------------
   Lin & Lore - kortingsregel in de winkelwagenlade

   snippets/cart-drawer.liquid rendert cart.cart_level_discount_applications
   nergens. Dit bestand tekent die regel zelf en hertekent hem zodra het
   subtotaal verandert. Het toont de echte titel van de korting uit Shopify
   (bijv. 'Buy 2, save 10%') met het werkelijk toegekende bedrag.

   18-10-2026: bedrag in de valuta van de winkelwagen (AUD/NZD) en in
   Australisch-Engelse notatie. Daarvoor stond hier hard EUR en nl-NL, waardoor
   AU/NZ-klanten '-€ 13,99' zagen.
   --------------------------------------------------------------- */

(function () {
  'use strict';

  function geld(centen, valuta) {
    var code = valuta || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(centen / 100);
    } catch (e) {
      return '$' + (centen / 100).toFixed(2);
    }
  }

  function stijl() {
    if (document.getElementById('ll-cart-korting-stijl')) return;
    var s = document.createElement('style');
    s.id = 'll-cart-korting-stijl';
    s.textContent =
      '.ll-cart-korting{display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:6px}' +
      '.ll-cart-korting__label{font-size:14px;line-height:1.4;color:var(--ll-muted,#6B655F)}' +
      '.ll-cart-korting__bedrag{font-size:14px;line-height:1.4;font-weight:600;white-space:nowrap;color:var(--ll-accent,#00875A)}';
    document.head.appendChild(s);
  }

  function teken(cart) {
    var vak = document.querySelector('.cart-drawer__summary');
    if (!vak) return;

    var oud = vak.querySelectorAll('[data-ll-korting]');
    for (var i = 0; i < oud.length; i++) oud[i].parentNode.removeChild(oud[i]);

    var kortingen = (cart && cart.cart_level_discount_applications) || [];
    if (!kortingen.length) return;

    stijl();
    var eerste = vak.firstElementChild;
    var valuta = (cart && cart.currency) || (document.querySelector('[data-cart-currency]') || {}).getAttribute && document.querySelector('[data-cart-currency]').getAttribute('data-cart-currency');

    for (var j = 0; j < kortingen.length; j++) {
      var k = kortingen[j];
      if (!k.total_allocated_amount) continue;

      var rij = document.createElement('div');
      rij.className = 'cart-drawer__summary-row ll-cart-korting';
      rij.setAttribute('data-ll-korting', '');

      var naam = document.createElement('span');
      naam.className = 'll-cart-korting__label';
      naam.textContent = k.title || 'Discount';

      var bedrag = document.createElement('span');
      bedrag.className = 'll-cart-korting__bedrag';
      bedrag.textContent = '−' + geld(k.total_allocated_amount, valuta);

      rij.appendChild(naam);
      rij.appendChild(bedrag);
      vak.insertBefore(rij, eerste);
    }
  }

  var bezig = false;
  var wacht = null;

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function ververs() {
    if (bezig) return;
    bezig = true;
    fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(teken)
      .catch(function () {})
      .then(function () { bezig = false; });
  }

  function straks() {
    clearTimeout(wacht);
    wacht = setTimeout(ververs, 120);
  }

  function start() {
    ververs();

    var totaal = document.querySelector('[data-cart-drawer-subtotal]');
    if (totaal) {
      new MutationObserver(straks).observe(totaal, { childList: true, characterData: true, subtree: true });
    }

    var lade = document.querySelector('[data-cart-drawer]');
    if (lade) {
      new MutationObserver(function () {
        if (lade.getAttribute('aria-hidden') === 'false') straks();
      }).observe(lade, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
